export default __webpack_public_path__ + "static/media/250.3941031b.png";